module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapname1"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Napoleon in classic end-of-empire garb. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Napoleon I in 1814")]), _vm._v(" by Jean-Louis-Ernest Meissonier)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1815 saw the revival of guerrilla warfare. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Chouan ambush")]), _vm._v(", Évariste Carpentier)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("During the Hundred Days peasant rebels enjoyed much popular support. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Chouan band")]), _vm._v(", Charles Fortin)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("French conscripts march off to glory. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Departure of the Conscripts in 1807")]), _vm._v(" by Louis Léopold Boilly)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Battle of Leipzig. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Battle of Leipzig,1813, French Infantry Defend Against a Prussian Assault")]), _vm._v(" by Paul-Émile Boutigny)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A somber picture replete with images of bleakness and exhaustion. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Napoleon and His Staff, 1814")]), _vm._v(", by Jean-Louis-Ernest Meissonier)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Marshal Marmont at the defence of Paris, 1814. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(La Barrière de Clichy , 1814")]), _vm._v(", by Horace Vernet)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The myth of 1814 encapsulated. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scene from the French Campaign, 1814")]), _vm._v(", by Horace Vernet)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Battle of Bayonne. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Sortie from Bayonne, 1814")]), _vm._v(", by Thomas Sutherland)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Emperor Alexander and his staff on the heights of Montmartre. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Battle of Paris, 1814")]), _vm._v(", by Gottfried Willewalde)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Alexander I and Frederick William III enter Paris. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Russian army, Paris, 1814")]), _vm._v(", artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Imperial Guard weeps as it bids farewell to Napoleon. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Adieux de Napoléon à la Garde impériale")]), _vm._v(" by Antoine Montfort)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cartoon mocking Napoleon. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Journey of a Modern Hero to the Island of Elba")]), _vm._v(" by George Cruikshank)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Napoleon says goodbye to Elba. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Napoleon Bonaparte leaving Elba, 26 February 1815")]), _vm._v(", by Joseph Beaume)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The French army rushes to do homage to Napoleon. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Napoleon’s Return from Elba")]), _vm._v(" by Charles Steuben)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Caricature of Napoleon. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Wahre Abbildung des Eroberers Napoleon Bonaparte, Kaiser der Franzosen. Anno 1815)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Battle of Thouars. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Battle of Thouars, 1815")]), _vm._v(", artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Battle of Rocheservière. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Battle of Rochesevière, 1815")]), _vm._v(", artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Wellington. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Duke of Wellington")]), _vm._v(" after Sir Thomas Lawrence)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Blücher. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Gebhard Leberecht von Blücher")]), _vm._v(", artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Quatre Bras. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The 28th Regiment at Quatre Bras")]), _vm._v(" by Lady Butler)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Dutch troops at Waterloo. (Artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Imperial Guard at Waterloo. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Napoleon’s Last Grand Attack")]), _vm._v(" by Ernest Crofts)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Prussians at Plancenoit. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Prussian Attack on Plancenoit")]), _vm._v(" by Adolph Northen)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The French army streams away from Waterloo. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Flight of French army from Waterloo")]), _vm._v(", artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Napoleon in 1814. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Napoleon at Fontainebleau")]), _vm._v(", workshop of Paul Delaroche)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Fierce fighting in Alsace. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Siege of Strasbourg, 1815, Fighting at Oberhausbergen")]), _vm._v(", artist unknown)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The siege of Strasbourg. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Battle for Grimma Gate")]), _vm._v(" by Ernst Strassburger)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-958f6f6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_list.vue
// module id = 72
// module chunks = 0